"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var theme_1 = require("./theme");
var TableFooterCell = theme_1.withTableTheme(core_1.TableCell, 'TableFooterCell');
exports.default = TableFooterCell;
